import { axiosInstance } from "../../config/axios";
import { APIURL } from "../../configApi";

const ContactService = {};
ContactService.sendEmail = (data) => {
  return axiosInstance.post(`${APIURL}/global/contact_us`, data);
};

export default ContactService;
